var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import includes from 'lodash/includes';
import { Localize, Util } from '../../services';
var sortByCial = Util.createCialCountrySort({
  valueProperty: 'iso_alpha_3',
  labelProperty: 'translatedTitle'
});
export var getSortedCountries = function getSortedCountries(enums) {
  var countriesEnum = enums.countries;

  if (!countriesEnum) {
    return [];
  }

  var countries = countriesEnum.map(function (country) {
    return _extends({}, country, {
      translatedTitle: Localize.translate(country.title)
    });
  });
  return countries.sort(function (a, b) {
    a.translatedTitle.localeCompare(b.translatedTitle);
    return sortByCial(a, b);
  });
};
export var getCialCountries = function getCialCountries(enums) {
  var countriesEnum = enums.countries;

  if (!countriesEnum) {
    return [];
  }

  var countries = countriesEnum.filter(function (country) {
    return includes(country.labels, 'cial');
  }).map(function (country) {
    return _extends({}, country, {
      translatedTitle: Localize.translate(country.title)
    });
  });
  return countries.sort(function (a, b) {
    return sortByCial(a, b);
  });
};
export var getCcsCountries = function getCcsCountries(enums) {
  var countriesEnum = enums.countries;

  if (!countriesEnum) {
    return [];
  }

  var countries = countriesEnum.filter(function (country) {
    return includes(country.labels, 'ccs');
  }).map(function (country) {
    return _extends({}, country, {
      translatedTitle: Localize.translate(country.title)
    });
  });
  return countries.sort(function (a, b) {
    return sortByCial(a, b);
  });
};